/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * Integration logo strip — borrows trust from known brands.
 * Shows logos of real integrations that exist in the product.
 */

"use client";

import Link from "next/link";

const integrations = [
  { name: "QuickBooks", slug: "quickbooks" },
  { name: "Stripe", slug: "stripe" },
  { name: "Google", slug: "google" },
  { name: "Microsoft", slug: "microsoft" },
];

export function IntegrationsStrip() {
  return (
    <section
      className="py-6 bg-background-warm border-b border-border/40"
      aria-label="Integrations"
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 lg:px-20">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10">
          <span className="text-xs text-muted-foreground uppercase tracking-wider">
            Works with the tools you already use
          </span>
          <div className="flex items-center gap-8">
            {integrations.map((integration) => (
              <span
                key={integration.slug}
                className="text-sm font-medium text-muted-foreground/60 hover:text-muted-foreground transition-colors"
                title={integration.name}
              >
                {integration.name}
              </span>
            ))}
          </div>
          <Link
            href="/integrations"
            className="text-xs text-muted-foreground hover:text-foreground transition-colors underline underline-offset-2"
          >
            See all integrations
          </Link>
        </div>
      </div>
    </section>
  );
}
